import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyUrl: string;
    restricted: string;
    projectSettings: string;
    notifsTooltip: string;
    archived: string;
    avatarLabel: ({ name }: {
        name: string;
    }) => string;
    memberCountLabel: ({ count }: {
        count?: number;
    }) => string;
    getFormattedDate: (dateValue: Date) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label to copy project URL */
            copyUrl: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectItemDetailQS.copyUrl?c=dubbsl04cxng", defaultMessage: "Copy URL" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for restricted/private project */
            restricted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectItemDetailQS.restricted?c=1uwijwqg1t0rx", defaultMessage: "Restricted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to open project settings */
            projectSettings: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectItemDetailQS.projectSettings?c=2okd1owibl5lb", defaultMessage: "Project Settings" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text indicating notifications are enabled */
            notifsTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectItemDetailQS.notifsTooltip?c=yeox5ydsvj4z", defaultMessage: "Notifications are enabled" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for archived/inactive project */
            archived: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectItemDetailQS.archived?c=35x00t5ixqcwu", defaultMessage: "Inactive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for opening project */
            avatarLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ name }: {
                        name: string;
                    }): string => __intl__.intl().formatMessage({ id: "ProjectItemDetailQS.avatarLabel?c=1lk71r0o8kbok", defaultMessage: "Open {name}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Member count display with pluralization */
            memberCountLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count = 0 }: {
                        count?: number;
                    }): string => __intl__.intl().formatMessage({ id: "ProjectItemDetailQS.memberCountLabel?c=17p5u7xoeoh49", defaultMessage: "{count, plural, one {1 member} other {{count} members}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Formats the date with the medium format (i.e. Jan 15, 2026) */
            getFormattedDate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (dateValue: Date): string => { return __intl__.intl().formatMessage({ id: "ProjectItemDetailQS.getFormattedDate.0?c=2ag710a7orq8z", defaultMessage: "{dateValue, date, medium}" }, { dateValue: dateValue }); });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
